import styled from 'styled-components';

export const LastDealSection = styled.div`
    background: #fff;
    display: flex;
  
  &:after {
    content: "";
    background: #fff;
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
    padding: 11px;
    position: relative;
    right: 21px;
  }
  `;

export const LastDealWrapper = styled.div`
    background: #FFE4E5;
    padding: 4px 40px 4px 16px;
    display: flex;
    align-items: center;
  `;

export const LastMin = styled.div`
    background: linear-gradient(315deg, #FF6D38 0%, #FF3A5C 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 4px;
    margin-right: 4px;
  `;

export const LastMinTitle = styled.span`
    font-family: Quicksand;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    color: #FFF1ED;
    margin-left: 3px;
  `;

export const PersuasionText = styled.span`
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #46484D;
`;
